<template>
  <div class="input-add">
    <el-input v-model="name" :class="'level'+level" placeholder="输入标题，回车创建，ESC取消" ref="input" @keyup.native.enter="save"
              @blur="save"></el-input>
    <!--
    <div class="btn-ai flex">
      <vab-remix-icon icon-class="robot"
                      class="ver-middle m-r-4"/>
      AI 任务分解
    </div>
    -->
  </div>
</template>
<script>
export default {
  components: {},
  props: ['item', 'level', 'pid'],
  data() {
    return {
      name: '',
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    // save
    save() {
      this.$emit('save', this.name)
      this.name = ''
    },
    freshList() {
      this.$emit('freshList')
    },
  },
  computed: {}
}
</script>

<style lang="less" scoped>
.input-add {
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid #F0F0F0;

  /deep/ .el-input__inner {
    height: 50px;
    padding: 0 0 0 55px;
    border: none;
    color: #10141b;
  }

  /deep/ .level1 .el-input__inner {
    padding: 0 0 0 70px;
  }

  /deep/ .level2 .el-input__inner {
    padding: 0 0 0 100px;
  }

  .btn-ai {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 115px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid #704FF9;
    margin: 0 0 0 8px;
    cursor: pointer;
    font-size: 13px;
    color: #704FF9;
  }
}


</style>